import './MainMenu.css';

import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import over from 'lodash/over';

import { Menu } from 'antd';
import Pages from '@pages/names';
import Link from 'redux-first-router-link';
import { eventHandler, GAAction } from '@analytics';

export const itemsText = {
  [Pages.Matches]: 'Todos los partidos',
  [Pages.Snapshot]: 'Mi prode',
  [Pages.Ranking]: 'Ranking general',
  [Pages.MyProfile]: 'Perfil',
  [Pages.Scores]: 'Mis puntajes',
  [Pages.MyRankings]: 'Torneos de amigos',
  [Pages.Login]: 'Registrate!',
};

export const itemToRoute = {
  [Pages.Matches]: 'partidos',
  [Pages.Snapshot]: 'mi-mundialito',
  [Pages.MyRankings]: 'mis-torneos',
  [Pages.Scores]: 'puntajes',
  [Pages.MyProfile]: 'myprofile',
  [Pages.Login]: 'acceder',
};

export const MainMenu = ({
  selected,
  itemsKey,
  itemsText,
  isLoggedIn,
  onLogoutClick,
  mode,
  onLinkClick,
}) => {
  let items = [
    ...itemsKey.map((key) => ({
      label: (
        <Link
          onClick={onLinkClick}
          to={[itemToRoute[key] || (key === 'Home' ? '' : key.toLowerCase())]}
        >
          {itemsText[key]}
        </Link>
      ),
      key,
    })),
    {
      label: (
        <Link onClick={eventHandler(GAAction.ClickMenuRules)} to={['reglas']}>
          Reglas
        </Link>
      ),
      key: Pages.Rules,
    },
  ];

  if (isLoggedIn) {
    items = [
      ...items,
      {
        label: (
          <a
            onClick={over([eventHandler(GAAction.LogOutClick), onLogoutClick])}
          >
            Salir
          </a>
        ),
        key: 'login',
      },
    ];
  }

  return (
    <Menu
      className="MainMenu"
      mode={mode}
      selectedKeys={selected ? [selected] : noop()}
      defaultSelectedKeys={selected ? [selected] : noop()}
      items={items}
    />
  );
};

MainMenu.displayName = 'MainMenu';
MainMenu.propTypes = {
  selected: PropTypes.string,
  itemsKey: PropTypes.array,
  itemsText: PropTypes.object,
  isLoggedIn: PropTypes.bool,
  onLogoutClick: PropTypes.func,
  mode: PropTypes.string,
  onLinkClick: PropTypes.func,
};
MainMenu.defaultProps = {
  itemsKey: [],
  itemsText,
  isLoggedIn: false,
  onLogoutClick: noop,
  mode: 'horizontal',
  onLinkClick: noop,
};

export default MainMenu;
